import { UpdateFacilityDto } from '../../models/facilities/facility.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpHelper } from '@umss/shared/utils';
import { PagedResultDto } from '../../models';
import {
  CreateFacilityDto,
  FacilityDto,
  FacilitySearchDto
} from '../../models/facilities/facility.model';

@Injectable({ providedIn: 'root' })
export class FacilityService {
  private readonly base = '/api/facilities';

  constructor(private http: HttpClient) {}

  // ============================================
  // ENDPOINT 1: GET /api/facilities
  // Get all facilities with search and filtering (paged)
  // ============================================
  getAllFacilities(
    searchParams: FacilitySearchDto = {}
  ): Observable<PagedResultDto<FacilityDto>> {
    const params = HttpHelper.toHttpParams(searchParams);

    return this.http.get<PagedResultDto<FacilityDto>>(this.base, { params });
  }

  // ============================================
  // ENDPOINT 2: GET /api/facilities/{id}
  // Get facility by ID
  // ============================================
  getFacilityById(id: string): Observable<FacilityDto> {
    return this.http.get<FacilityDto>(`${this.base}/${id}`);
  }

  // ============================================
  // ENDPOINT 3: POST /api/facilities
  // Create new facility
  // ============================================
  createFacility(body: CreateFacilityDto): Observable<FacilityDto> {
    return this.http.post<FacilityDto>(this.base, body);
  }

  // ============================================
  // ENDPOINT 4: PUT /api/facilities/{id}
  // Update facility
  // ============================================
  updateFacility(id: string, body: UpdateFacilityDto): Observable<FacilityDto> {
    return this.http.put<FacilityDto>(`${this.base}/${id}`, body);
  }

  // ============================================
  // ENDPOINT 5: DELETE /api/facilities/{id}
  // Delete facility
  // ============================================
  deleteFacility(id: string): Observable<void> {
    return this.http.delete<void>(`${this.base}/${id}`);
  }
}
